import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import SchedulerExecuteLogDetailTable from './components/SchedulerExecuteLogDetailTable'

const SchedulerExecuteOrders: FC = () => {
  const intl = useIntl()

  return (
    <>
      <PageTitle breadcrumbs={
        [
          {
            title: intl.formatMessage({id: 'MENU.SCHEDULER-LOGS'}),
            path: '/schedulers/logs',
            isSeparator: false,
            isActive: true,
          },
          {
            title: 'dash',
            path: 'dash',
            isSeparator: true,
            isActive: true,
          },
        ]
      }>
        {intl.formatMessage({id: 'SCHEDULER.LOGS.ORDER.PAGE_TITLE'})}
      </PageTitle>
      <SchedulerExecuteLogDetailTable />
    </>
  )
}

export default SchedulerExecuteOrders
